import React,{Component} from 'react';
import {Form, FormGroup, Col, Label} from 'reactstrap';
import {ReactComponent as ColorTheme} from '../../../../Assets/images/Dashboard2.svg';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import { FaRegCalendarAlt } from 'react-icons/fa';

class ReportSetting extends Component{

    constructor(props){
        super(props);
        this.state = {
            startDate: null,
            endDate: null,
            periodId: "5",
            ColorTheme: "1",
            periodType: props.reportType === "2" ? "3" : "1",
            groupById: "0",
            isStartDateEmpty:false,
            isEndDateEmpty: false,
            color:{
                black: true,
                blue: false,
                gray: false,
                green: false,
                orange: false,
                yellow: false
            }
        }
        this.OnClickImage = this.OnClickImage.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(this.props !== nextProps){
            this.setState({isStartDateEmpty: this.props.reportType === "1" ? nextProps.dateValidation[0] : nextProps.dateValidation[2], 
                           isEndDateEmpty: this.props.reportType === "1" ? nextProps.dateValidation[1] : nextProps.dateValidation[3], 
                           startDate: this.props.reportType === "1" ? nextProps.dataValue[0] : nextProps.dataValue[2], 
                           endDate: this.props.reportType === "1" ? nextProps.dataValue[1] : nextProps.dataValue[3],
                           periodId: this.props.reportType === "1" ? nextProps.dataValue[5] : nextProps.dataValue[7],
                           ColorTheme: nextProps.dataValue[8],
                           periodType: this.props.reportType === "1" ? nextProps.dataValue[4] : nextProps.dataValue[6],
                           groupById: nextProps.dataValue[9]
                        }, () => {
                            switch(this.state.ColorTheme){
                                case "1":
                                    this.setState({color:{black:true}});
                                    break;
                                case "2":
                                    this.setState({color:{blue:true}});
                                    break;
                                case "3":
                                    this.setState({color:{gray:true}});
                                    break;
                                case "4":
                                    this.setState({color:{green:true}});
                                    break;
                                case "5":
                                    this.setState({color:{orange:true}});
                                    break;
                                case "6":
                                    this.setState({color:{yellow:true}});
                                    break;   
                                default:
                                    this.setState({color:{black:true}});
                                    break;
                            }
                        });
        }
    }

    OnClickImage(e){
        var value = document.getElementById(e.currentTarget.id).attributes.value.nodeValue
        switch(value){
            case "1":
                this.setState({color:{black:true}});
                this.props.reportSetting('ColorTheme',value)
                break;
            case "2":
                this.setState({color:{blue:true}});
                this.props.reportSetting('ColorTheme',value)
                break;
            case "3":
                this.setState({color:{gray:true}});
                this.props.reportSetting('ColorTheme',value)
                break;
            case "4":
                this.setState({color:{green:true}});
                this.props.reportSetting('ColorTheme',value)
                break;
            case "5":
                this.setState({color:{orange:true}});
                this.props.reportSetting('ColorTheme',value)
                break;
            case "6":
                this.setState({color:{yellow:true}});
                this.props.reportSetting('ColorTheme',value)
                break;   
            default:
                this.setState({color:{black:true}});
                this.props.reportSetting('ColorTheme',"1")
                break;
        }
    }

    render(){
        let label = this.props.getLabels, period_options, PMperiod_options, groupBy_options;
        var lstGroupBy = [], lstGroupByPM = [], lfinalGroupBy;
        let WOPreferences = this.props.getWorkorderPreferences;
        let PMPreferences = this.props.getPreferences;
        let IsOnPremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;

        var selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label>

        var lPeriod =  label !== undefined && label['WorkOrderReports.Period.Options.Text'] !== undefined ? label['WorkOrderReports.Period.Options.Text'].split(',') : "";
        if(lPeriod.length > 0){
            period_options = lPeriod.map(el => (
                <option id={el} value={el} key={el} data-testid="select-option-period">{label['WorkOrderReports.Period.'+el+'.Text']}</option>
            ))
        }

        var PM_lPeriod = (label !== undefined && label['PMReports.Period.Options.Text'] !== undefined) ? label['PMReports.Period.Options.Text'].split(',') : "";
        if(PM_lPeriod.length > 0){
            PMperiod_options = PM_lPeriod.map(el => (
                <option id={el} value={el} key={el} data-testid="select-option-period">{label['PMReports.Period.'+el+'.Text']}</option>
            ))
        }
        
        if(WOPreferences !== undefined && WOPreferences !== ""){
            var status = (WOPreferences.filter(x => x.field === "Status"));             
            var assignedTo = (WOPreferences.filter(x => x.field === "Assigned To"));             
            var building = (WOPreferences.filter(x => x.field === "Building"));           
            var tenant = (WOPreferences.filter(x => x.field === "Tenant"));           
            var problem = (WOPreferences.filter(x => x.field === "Problem"));
        }

        lstGroupBy.push(assignedTo !== undefined && assignedTo.length > 0 ? {value:assignedTo[0].fieldLabel,id:'2'} : {value:'Assigned To',id:'2'});
        lstGroupBy.push(building !== undefined && building.length > 0 ? {value: building[0].fieldLabel,id:'3'} : {value:'Building',id:'3'});
        lstGroupBy.push(problem !== undefined && problem.length > 0 ? {value:problem[0].fieldLabel,id:'5'} : {value:'Problem',id:'5'});
        lstGroupBy.push(status !== undefined && status.length > 0 ? {value:status[0].fieldLabel,id:'1'} : {value:'Status',id:'1'});
        lstGroupBy.push(tenant !== undefined && tenant.length > 0 ? {value:tenant[0].fieldLabel,id:'4'} : {value:'Tenant',id:'4'});

        if(PMPreferences !== undefined && PMPreferences !== ""){
            var pm_status = (PMPreferences.filter(x => x.field === "Status"));            
            var pm_assignedTo = (PMPreferences.filter(x => x.field === "Assigned To"));            
            var pm_building = (PMPreferences.filter(x => x.field === "Building"));         
            var pm_equipment = (PMPreferences.filter(x => x.field === "Equipment"));
        }

        lstGroupByPM.push(pm_assignedTo !== undefined && pm_assignedTo.length > 0 ? {value:pm_assignedTo[0].fieldLabel,id:'2'} : {value:'Assigned To',id:'2'});
        lstGroupByPM.push(pm_building !== undefined && pm_building.length > 0 ? {value:pm_building[0].fieldLabel,id:'3'} : {value:'Building',id:'3'});
        lstGroupByPM.push(pm_equipment !== undefined && pm_equipment.length > 0 ? {value:pm_equipment[0].fieldLabel,id:'6'}: {value:'Equipment',id:'6'});
        lstGroupByPM.push(pm_status !== undefined && pm_status.length > 0 ? {value:pm_status[0].fieldLabel,id:'1'}: {value:'Status',id:'1'}); 
    
        if(this.props.reportType === "2"){
            lfinalGroupBy = lstGroupByPM;
        }
        else{
            lfinalGroupBy = lstGroupBy;
        }

        groupBy_options = lfinalGroupBy.map(el => (
            <option id={el.id} value={el.id} key={el.id} data-testid="select-options-groupby">{el.value}</option>
        ))

        
        return(
            <div>
                <Form className="form-visible">
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_settings" className="reportsHeaderlbl">{label['WorkOrderReports.Settings.Text'] !== undefined ? label['WorkOrderReports.Settings.Text'] : "Settings"}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom:'0px'}}>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_colortheme" style={{ marginBottom: "0px" }} className="workorderlbl">{label['WorkOrderReports.ColorTheme.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Text'] : "Color Theme"}</Label>                        
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{size:1}} style={{marginRight:'10px'}}>
                            <div data-testid="svg" className={this.state.color.black ? "reports-colorTheme-box":"reports-colorTheme"}>
                                <ColorTheme  id="img_colortheme_black" style={{width:'20px', paddingLeft:'5px', height:'20px'}} onClick={this.OnClickImage} value="1"/>
                                <Label className="reports-colorTheme-label">{label['WorkOrderReports.ColorTheme.Black.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Black.Text'] : "Black"}</Label>
                            </div>
                        </Col>
                        <Col sm={{size:1}} style={{marginRight:'10px'}}>
                            <div data-testid="svg" className={this.state.color.blue ? "reports-colorTheme-box":"reports-colorTheme"}>
                                <ColorTheme id="img_colortheme_blue" style={{width:'20px', paddingLeft:'5px', height:'20px'}} fill="#3C5E99" onClick={this.OnClickImage} value="2"/>&nbsp;&nbsp;
                                <Label className="reports-colorTheme-label">{label['WorkOrderReports.ColorTheme.Blue.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Blue.Text'] : "Blue"}</Label>
                            </div>
                        </Col>
                        <Col sm={{size:1}} style={{marginRight:'10px'}}>
                            <div data-testid="svg" className={this.state.color.gray ? "reports-colorTheme-box":"reports-colorTheme"}>
                                <ColorTheme  id="img_colortheme_gray" style={{width:'20px', paddingLeft:'5px', height:'20px'}} fill="#666666" onClick={this.OnClickImage} value="3"/>&nbsp;
                                <Label className="reports-colorTheme-label">{label['WorkOrderReports.ColorTheme.Gray.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Gray.Text'] : "Gray"}</Label>
                            </div>
                        </Col>
                        <Col sm={{size:1}} style={{marginRight:'10px'}}>
                            <div data-testid="svg" className={this.state.color.green ? "reports-colorTheme-box":"reports-colorTheme"}>
                                <ColorTheme  id="img_colortheme_green" style={{width:'20px', paddingLeft:'5px', height:'20px'}} fill="#61AE33" onClick={this.OnClickImage} value="4"/>
                                <Label className="reports-colorTheme-label">{label['WorkOrderReports.ColorTheme.Green.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Green.Text'] : "Green"}</Label>
                            </div>
                        </Col>
                        <Col sm={{size:1}} style={{marginRight:'10px'}}>
                            <div data-testid="svg" className={this.state.color.orange ? "reports-colorTheme-box":"reports-colorTheme"}>
                                <ColorTheme  id="img_colortheme_orange" style={{width:'20px', paddingLeft:'5px', height:'20px'}} fill="#FB9A09" onClick={this.OnClickImage} value="5"/>
                                <Label className="reports-colorTheme-label">{label['WorkOrderReports.ColorTheme.Orange.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Orange.Text'] : "Orange"}</Label>
                            </div>
                        </Col>
                        <Col sm={{size:1}} style={{marginRight:'10px'}}>
                            <div data-testid="svg" className={this.state.color.yellow ? "reports-colorTheme-box":"reports-colorTheme"}>
                                <ColorTheme  id="img_colortheme_yellow" style={{width:'20px', paddingLeft:'5px', height:'20px'}} fill="#DED204" onClick={this.OnClickImage} value="6"/>
                                <Label className="reports-colorTheme-label">{label['WorkOrderReports.ColorTheme.Yellow.Text'] !== undefined ? label['WorkOrderReports.ColorTheme.Yellow.Text'] : "Yellow"}</Label>
                            </div>
                        </Col>
                    </FormGroup>
                    
                    {(this.props.reportType !== "3" && this.props.reportType !== "4") ?
                    <FormGroup row style={{marginBottom:'0.5rem'}}>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_reportperiod" className="workorderlbl">{label['WorkOrderReports.ReportPeriod.Text'] !== undefined ? label['WorkOrderReports.ReportPeriod.Text'] : "Report Period"}</Label>                        
                        </Col>
                        <Col sm={(IsOnPremise) ? {size: 4} : {size: 3}}>
                        {
                         (this.props.reportType !== "2") ? 
                           <div> 
                               <input type="radio" id="radio_createddate" name="reportPeriod" style={{marginRight:'5px'}} checked={this.state.periodType === "1"} onClick={() => this.props.reportSetting('WOPeriodType',"1")}/>
                                <Label className="reportsTypelbl" style={{verticalAlign:'middle'}}>{label['WorkOrderReports.CreatedDate.Text'] !== undefined ? label['WorkOrderReports.CreatedDate.Text'] : "Created Date"}</Label> 
                            </div> :
                            <div>
                                <input type="radio" id="radio_duedate" name="reportPeriod" style={{marginRight:'5px'}} checked={this.state.periodType === "3"} onClick={() => this.props.reportSetting('PMPeriodType',"3")}/>
                                <Label className="reportsTypelbl" style={{verticalAlign:'middle'}}>{label['WorkOrderReports.DueDate.Text'] !== undefined ? label['WorkOrderReports.DueDate.Text'] : "Due Date"}</Label>
                            </div> 
                        }
                        </Col>
                        {
                         (this.props.reportType !== "2") ? 
                        <Col sm={{ size: 3}}>
                            <input type="radio" id="radio_closeddate" name="reportPeriod" style={{marginRight:'5px'}} checked={this.state.periodType === "2"} onClick={() => this.props.reportSetting('WOPeriodType',"2")}/>
                            <Label className="reportsTypelbl" style={{verticalAlign:'middle'}}>{label['WorkOrderReports.ClosedDate.Text'] !== undefined ? label['WorkOrderReports.ClosedDate.Text'] : "Closed Date"}</Label>
                        </Col> : 
                        <Col sm={{ size: 3}}>
                        <input type="radio" id="radio_closeddate" name="reportPeriod" style={{marginRight:'5px'}} checked={this.state.periodType === "2"} onClick={() => this.props.reportSetting('PMPeriodType',"2")}/>
                        <Label className="reportsTypelbl" style={{verticalAlign:'middle'}}>{label['WorkOrderReports.ClosedDate.Text'] !== undefined ? label['WorkOrderReports.ClosedDate.Text'] : "Closed Date"}</Label>
                    </Col> 
                        }
                    </FormGroup>
                    : "" }
                    {(this.props.reportType !== "3" && this.props.reportType !== "4") ?
                    <FormGroup row style={{ marginBottom : (this.state.periodId === "10") ? '' : '1.5rem' }}>
                        <Col sm={{ size: 12 }}>
                        {
                         (this.props.reportType !== "2") ? 
                            <select id="select_reportperiod" data-testid="select-period" value={this.state.periodId} className="minimal workorderedit-dropdown" style={{ width: '100%' }} onChange={(e) => this.props.reportSetting('WOPeriod',e.target.value)}>
                                {period_options}
                            </select> :
                            <select id="select_reportperiod" data-testid="select-period" value={this.state.periodId} className="minimal workorderedit-dropdown" style={{ width: '100%' }} onChange={(e) => this.props.reportSetting('PMPeriod',e.target.value)}>
                                {this.state.periodType === "3" ? PMperiod_options : period_options}
                            </select>
                        }
                        </Col>
                    </FormGroup>
                    : "" }
                    {
                    (this.state.periodId === "10" && this.props.reportType !== "3" && this.props.reportType !== "4") ?
                    <FormGroup row style={{marginBottom:(this.state.isStartDateEmpty || this.state.isEndDateEmpty) ? '0px': '' }}>  
                            <Col sm={{ size: 12}}>
                               <Label id="label_custom_startdate" className={this.state.isStartDateEmpty ? "errortext workorderlbl" : "workorderlbl"} style={{position:'relative', verticalAlign:'Top'}}>{label['WorkOrderReports.StartDate.Text'] !== undefined ? label['WorkOrderReports.StartDate.Text'] : "Start Date*"}</Label>
                                <label style={{cursor:'pointer', width:(IsOnPremise) ? '150px':'180px', marginLeft:(IsOnPremise) ?'6px':'10px'}}>
                                    <DatePicker id="input_custom_startdate" selected={this.state.startDate} maxDate={this.state.endDate} onChange={date => {this.setState({startDate:date}); this.props.reportSetting(this.props.reportType === "1" ? 'WOStartDate' : 'PMStartDate',date) }} className={this.state.isStartDateEmpty ? "errorhighlight workorderedit-dropdown pm_bg_color Pm_Full_Width" : "workorderedit-dropdown pm_bg_color Pm_Full_Width"}/>
                                        <div className={IsOnPremise ? "pm_calendardiv":"pm_calendardiv1"} id="img_custom_startdate">
                                            <FaRegCalendarAlt className="pm_calendarbox" />                                            
                                        </div> 
                                    <span hidden={!this.state.isStartDateEmpty}>{selecterrortext}</span>                                   
                                </label>
                                <div style={{float:'right'}}>
                                    <Label id="label_custom_enddate" className={this.state.isEndDateEmpty ? "errortext workorderlbl" :"workorderlbl"} style={{position:'relative', verticalAlign:'Top'}}>{label['WorkOrderReports.EndDate.Text'] !== undefined ? label['WorkOrderReports.EndDate.Text'] : "End Date*"}</Label>
                                    <label style={{cursor:'pointer',width:(IsOnPremise) ? '150px':'180px', marginLeft:(IsOnPremise) ?'6px':'10px'}}>
                                        <DatePicker id="input_custom_enddate" selected={this.state.endDate} minDate={this.state.startDate} onChange={date => {this.setState({endDate:date}); this.props.reportSetting(this.props.reportType === "1" ? 'WOEndDate' : 'PMEndDate',date) }} className={this.state.isEndDateEmpty ? "errorhighlight workorderedit-dropdown pm_bg_color Pm_Full_Width" : "workorderedit-dropdown pm_bg_color Pm_Full_Width"}/>
                                            <div className={IsOnPremise ? "pm_calendardiv":"pm_calendardiv1"} id="img_custom_enddate">
                                                <FaRegCalendarAlt className="pm_calendarbox" />
                                            </div>
                                        <span hidden={!this.state.isEndDateEmpty}>{selecterrortext}</span> 
                                    </label> 
                                </div>                     
                            </Col>
                    </FormGroup>: "" 
                    } 

                    {(this.props.reportType !== "3" && this.props.reportType !== "4") ?
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_groupby" style={{ marginBottom: "0px" }} className="workorderlbl">{label['WorkOrderReports.GroupBy.Text'] !== undefined ? label['WorkOrderReports.GroupBy.Text'] : "Group By"}</Label>                        
                        </Col>
                        <Col sm={{ size: 12 }}>
                            <select id="select_groupby" data-testid="select-groupby" value={this.state.groupById} className="minimal workorderedit-dropdown" style={{ width: '100%' }} onChange={(e) => this.props.reportSetting('GroupBy',e.target.value)}>
                                <option id="0" value="0" data-testid="select-options-groupby">{label['WorkOrderReports.GroupBy.0.Text'] !== undefined ? label['WorkOrderReports.GroupBy.0.Text'] : "None"}</option> 
                                {groupBy_options}
                            </select>
                        </Col>
                    </FormGroup> : "" }
                </Form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        OnPremises: state.authService.IsOnPremise,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps,mapDispatchToProps) (ReportSetting);